import React from 'react';
import { motion } from 'framer-motion';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, Package, ShoppingCart, LogOut } from 'lucide-react';

const AdminSidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin/dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { path: '/admin/stock', icon: <Package size={20} />, label: 'Stock' },
    { path: '/admin/orders', icon: <ShoppingCart size={20} />, label: 'Orders' },
    { path: '/admin/revenue', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>, label: 'Revenue' },
  ];

  return (
    <div className="w-64 h-screen bg-card border-r border-border/50 flex flex-col fixed left-0 top-0 z-50">
      {/* Logo */}
      <div className="p-6 border-b border-border/50">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-primary" data-testid="sidebar-logo-accent" />
          <h1 className="text-2xl font-heading font-bold tracking-wider text-primary" data-testid="sidebar-logo">GRINDNATION</h1>
        </div>
        <p className="text-gray-400 text-xs font-mono mt-2 uppercase tracking-wider">Admin Panel</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 mb-2 font-heading tracking-wider uppercase text-sm transition-colors ${
                isActive
                  ? 'bg-primary/10 border-l-2 border-primary text-primary'
                  : 'text-gray-400 hover:text-primary hover:bg-primary/5'
              }`
            }
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            {item.icon}
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-border/50">
        <motion.button
          whileHover={{ x: 4 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 w-full text-destructive hover:bg-destructive/10 font-heading tracking-wider uppercase text-sm transition-colors"
          data-testid="logout-button"
        >
          <LogOut size={20} />
          Logout
        </motion.button>
      </div>
    </div>
  );
};

export default AdminSidebar;